import styled from "styled-components";
import firstGift from "./FirstGift.png"

const FirstGift = styled.img`
width: 288px;
height: 128px;
  flex-grow: 0;
  object-fit: contain;

    `

export default () => (
    <FirstGift src={"/gift-1.png"} alt={"첫번째 선물"}/>
)


